import type { ReactNode } from "react";

const URL_RE =
  /((?:https?:\/\/|www\.)[^\s<]+[^\s<.,;:!?"')\]]|[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/gi;

function normalizeHref(raw: string) {
  if (raw.includes("@") && !raw.includes("://") && !raw.startsWith("www.")) {
    return `mailto:${raw}`;
  }
  if (raw.startsWith("www.")) return `https://${raw}`;
  return raw;
}

/** Split text into plain + clickable link nodes. */
export function linkifyText(text: string): ReactNode[] {
  if (!text) return [];
  const nodes: ReactNode[] = [];
  let lastIndex = 0;
  const re = new RegExp(URL_RE.source, "gi");
  let match: RegExpExecArray | null;
  let key = 0;

  while ((match = re.exec(text)) !== null) {
    const value = match[0];
    if (match.index > lastIndex) {
      nodes.push(text.slice(lastIndex, match.index));
    }
    const href = normalizeHref(value);
    nodes.push(
      <a
        key={`link-${key++}`}
        href={href}
        target={href.startsWith("mailto:") ? undefined : "_blank"}
        rel="noopener noreferrer"
        className="break-all text-sky-600 underline underline-offset-2 hover:text-sky-700 dark:text-sky-400"
        onClick={(event) => event.stopPropagation()}
      >
        {value}
      </a>,
    );
    lastIndex = match.index + value.length;
  }

  if (lastIndex < text.length) {
    nodes.push(text.slice(lastIndex));
  }

  return nodes.length ? nodes : [text];
}
